import * as actionTypes from '../actionTypes';

const initialState = {
  token: null,
  isFirstLoggedIn: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTHENTICATE: {
      return {
        ...state,
        token: action.token,
        isFirstLoggedIn: true,
      };
    }
    case actionTypes.LOGOUT: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
};

export default authReducer;
